import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CommonValidators {
  static readonly validEmail: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value?.includes('@')) {
      return null;
    }
    return { validEmail: false };
  };

  static readonly containsUppercaseCharacter: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (/[A-Z]/.test(control.value)) {
      return null;
    }

    return { containsUppercaseCharacter: false };
  };

  static readonly containsLowercaseCharacter: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (/[a-z]/.test(control.value)) {
      return null;
    }

    return { containsLowercaseCharacter: false };
  };

  static readonly containsNumber: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (/\d/.test(control.value)) {
      return null;
    }

    return { containsNumber: false };
  };

  static equalAsIn(controlNameToCompareAgainst: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const secondControl = control.parent?.get(controlNameToCompareAgainst);
      return control && secondControl && control.value === secondControl.value ? null : { equalAsIn: false };
    };
  }
}
